/* tslint:disable */
/* eslint-disable */

/**
 * Status of Calculation (Trans)
 */
export enum CalculationStatusType {
  Error = 'ERROR',
  Error1Uniform = 'ERROR1UNIFORM',
  Error2Twist = 'ERROR2TWIST',
  Error3Hardcenter = 'ERROR3HARDCENTER',
  Error3Hardedge = 'ERROR3HARDEDGE',
  Errortrans1Overall = 'ERRORTRANS1OVERALL',
  Errortrans2Overall = 'ERRORTRANS2OVERALL',
  Errortrans2Maxonefield = 'ERRORTRANS2MAXONEFIELD',
  Errortrans3Onesided = 'ERRORTRANS3ONESIDED',
  Errortrans4Twosided = 'ERRORTRANS4TWOSIDED',
  Errorspe1Sheer = 'ERRORSPE1SHEER',
  Errorspe1Gravel = 'ERRORSPE1GRAVEL',
  Stresserror = 'STRESSERROR',
  None = 'NONE',
  Draft = 'DRAFT',
  Theory = 'THEORY',
  Data = 'DATA',
  Done = 'DONE',
  Ok = 'OK',
  Warning = 'WARNING'
}
